import Vue from 'vue';
import Vuex from 'vuex';
import axios from 'axios';
import data from './modules/data.js';
import build from './modules/build.js';
import step from './modules/step.js';
import filters from './modules/filters.js';
import categoryProducts from './modules/category-products.js';
import brandColorSelection from './modules/brand-color-selection.js';
import order from './modules/order.js';
import popup from './modules/popup.js';
import discount from './modules/discount.js';
import roomOptions from './modules/room-options.js';
import { i18n } from '../main';

Vue.use(Vuex);

export default window.switch_store = new Vuex.Store({
  modules: {
    data,
    build,
    step,
    filters,
    'category-products': categoryProducts,
    'brand-color-selection': brandColorSelection,
    order,
    popup,
    discount,
    roomOptions,
  },

  state: {
    appPath: process.env.VUE_APP_APP_URL,
    api: process.env.VUE_APP_API_URL,
    environment: null,
    bodyBackground: undefined,
    backgroundColorType: '',
    changeAmountEnabled: false,
    apiPending: false,
    loading: true,
  },

  actions: {
    async init({ dispatch, state, getters, commit }) {
      const dataset = document.getElementById('switch-gen').dataset;
      const datasetEnvironment = dataset.env;

      if (dataset.discount !== undefined) {
        commit('discount/setDiscountGroups', eval(dataset.discount));
      }

      const url = new URLSearchParams(window.location.search);
      const urlEnvironment = url.get('environment');

      const environmentId =
        urlEnvironment ||
        datasetEnvironment ||
        process.env.VUE_APP_ENVIRONMENT_ID ||
        2;

      state.environment = parseInt(environmentId);

      axios.defaults.baseURL = `${state.api}/${state.environment}/switch`;

      dispatch('data/fetchEnvironmentInformation').then(() => {
        if (getters['data/getEnvironmentLocale'] !== null) {
          i18n.locale = getters['data/getEnvironmentLocale'];
        }
      });

      dispatch('data/fetchSettings');
      dispatch('data/fetchInfoPopups');
      dispatch('roomOptions/fetchRoomTypes');
      dispatch('roomOptions/fetchWallTypes');

      await dispatch('category-products/getCategoryProducts');

      const urlParams = new URLSearchParams(window.location.search);
      const buildIds = urlParams.getAll('builds');

      const urlsToDelete = [];

      if (buildIds.length > 0) {
        commit('setLoading', true);

        urlsToDelete.push('builds');

        await dispatch('build/fetchUrlRooms', buildIds[0].split(','));
      }

      const step = urlParams.get('step');

      if (step) {
        urlsToDelete.push('step');

        if (Number(step) === 2) {
          await dispatch('step/goToStepBrandColorSelection');
          commit('brand-color-selection/setAllRoomsSelected', true);
        }

        if (Number(step) === 3) {
          await dispatch('brand-color-selection/getBrandColorTypes');

          await dispatch('step/goToStepFinishOrder');
        }
      }

      if (urlsToDelete.length) {
        urlsToDelete.forEach((urlToDelete) => urlParams.delete(urlToDelete));

        const paramsUrl = urlParams.toString()
          ? `?${urlParams.toString()}`
          : '';

        window.history.replaceState(
          {},
          document.title,
          `${window.location.pathname}${paramsUrl}`
        );
      }

      commit('setLoading', false);
    },
  },

  mutations: {
    setBodyBackground(state, bg) {
      state.bodyBackground = bg;
    },

    setChangeAmountEnabled(state, value) {
      state.changeAmountEnabled = value;
    },

    setPending(state, bool) {
      state.apiPending = bool;
    },

    setLoading(state, bool) {
      state.loading = bool;
    },
  },

  getters: {
    getBodyBackground(state) {
      return state.bodyBackground;
    },

    getChangeAmountEnabled(state) {
      return state.changeAmountEnabled;
    },

    getApiUrl(state) {
      return `${state.api}/${state.environment}/switch`;
    },

    getPending(state) {
      return state.apiPending;
    },

    isLoading(state) {
      return state.loading;
    },
  },
});
